import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import './Table.css'
import { NavLink } from 'react-router-dom';

export default function BasicTable({ data, sector }) {
    const uniqueData = data.filter(
        (item, index, arr) => arr.findIndex((i) => i.cftc_contract_market_code === item.cftc_contract_market_code) === index
    );
    const limitedData = uniqueData.slice(0, 10);

    const tableCellStyle = {
        textTransform: 'uppercase',
        transition: 'background-color 0.3s ease', // Transition for smoother hover effect
        '&:hover': {
            backgroundColor: '#f2f2f2', // Change the background color on hover
        },
    };
    return (
        <>
            <TableContainer component={Paper} sx={{ height: 'fit-content' }}>
                <div className="tableheader">
                    <p className="tablehead">{sector}</p>
                    <div className="legacydiv">
                        <NavLink className="legacy" to="/cot/legacy-futures">More in Legacy futures</NavLink>
                        <NavLink className="legacy" to="/cot/futures">More in Legacy</NavLink>
                    </div>
                </div>
                <Table sx={{ minWidth: 450 }} aria-label="simple table">
                    <TableBody>
                        {limitedData.map((row) => (
                            <TableRow
                                key={row.symbol}
                                sx={{
                                    '&:last-child td, &:last-child th': { border: 0 },
                                    transition: 'background-color 0.2s ease',
                                    '&:hover': {
                                        backgroundColor: '#cccccc', // Change the background color of the row on hover
                                    },
                                }}>
                                <TableCell component="th" scope="row" sx={{ textTransform: 'uppercase' }}>
                                    {row.symbol}
                                </TableCell>
                                <TableCell align="left" sx={{ textTransform: 'uppercase' }}>
                                    {row.short_name}
                                </TableCell>
                                <TableCell align="right">
                                    <NavLink to={`/cot/legacy-futures/${row.symbol}`} style={{ textDecoration: "none", color: "#00af65" }} className="cotlink">COT Legacy</NavLink>
                                </TableCell>
                                <TableCell align="right">
                                    <NavLink to={`/cot/futures/fin/${row.symbol}`} className="cotlink" style={{ textDecoration: "none", color: "#00af65" }}>COT</NavLink>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}
